import { defineQuiz } from "./_schema";
import { boostQuiz } from "./boost";

/**
 * QUIZ-V6-GL -- tracking-isolated duplicate of the quiz-v6 quiz (quiz-v6).
 *
 * Analytics in this system is keyed by SLUG, not URL (admin funnel,
 * quiz_submissions.quiz_slug, Klaviyo event/profile props). Google-sourced
 * traffic to the quiz-v6 funnel needs to be attributable separately, so we
 * mount an identical quiz under a distinct slug and publish it at
 * /pages/quiz-v6-gl. Same on-screen experience, separate row everywhere in
 * our own analytics.
 *
 * This is a THIN RE-EXPORT of quiz-v6: it spreads `boostQuiz` and overrides
 * only `id` / `slug`. The two quizzes
 * share the same `questions` array, `classifier`, and `deriveProfile` BY
 * REFERENCE, so they can never drift -- any future edit to quiz-v6's content
 * propagates here automatically. If the two are ever meant to diverge, that
 * becomes a deliberate change (stop spreading, fork the fields).
 *
 * NO Intelligems experiment reaches this page today, because quiz-v6 carries
 * none: MM-0093 concluded 2026-09-01 with the variant losing and was removed
 * from the parent. So this page does not touch `window.igData` and pays no
 * resolver poll.
 *
 * Inheritance is the DEFAULT here, and that is deliberate. This file spreads
 * quiz-v6, so arming quiz-v6 arms this page automatically -- which is what
 * MM-0093 wanted: a screen-order test that skipped the traffic-source clones
 * would leave them serving a different screen order from the quiz they are
 * supposed to be identical to. Opting this slug out of a FUTURE test means
 * adding `experiment: undefined` here explicitly, as it was while MM-0064 was
 * live (to keep this page's paid traffic off the resolver's latency path).
 * Per-slug reading works either way -- our rollup splits arms by slug.
 *
 * See docs/specs/2026-07-16-quiz-v6-gl-tracking-duplicate-design.md.
 */
export const quizV6GlQuiz = defineQuiz({
  ...boostQuiz,
  id: "quiz-v6-gl",
  slug: "quiz-v6-gl",
});
